import { QualificationDetailSortEnum } from "../../../common/enums/QualificationDetailSortEnum";
import { setSortEducators } from "../QualificationDetailSlice";
import { Dispatch } from "redux";

interface Props {
    dispatch: Dispatch;
    sortEducators: {
        sortName: string;
        isSorted: boolean;
    };
}

export const handleEducatorSort = (props: Props) => () => {
    const { dispatch, sortEducators } = props;

    switch (sortEducators.sortName) {
        case QualificationDetailSortEnum.EDUCATOR:
            dispatch(
                setSortEducators({
                    sortName: sortEducators.isSorted
                        ? QualificationDetailSortEnum.EDUCATOR_ASC
                        : QualificationDetailSortEnum.EDUCATOR_DESC,
                    isSorted: !sortEducators.isSorted,
                }),
            );
            break;
        case QualificationDetailSortEnum.EDUCATOR_NAME:
            dispatch(
                setSortEducators({
                    sortName: sortEducators.isSorted
                        ? QualificationDetailSortEnum.EDUCATOR_NAME_ASC
                        : QualificationDetailSortEnum.EDUCATOR_NAME_DESC,
                    isSorted: !sortEducators.isSorted,
                }),
            );
            break;
        case QualificationDetailSortEnum.WEBSITE_URL:
            dispatch(
                setSortEducators({
                    sortName: sortEducators.isSorted
                        ? QualificationDetailSortEnum.WEBSITE_URL_ASC
                        : QualificationDetailSortEnum.WEBSITE_URL_DESC,
                    isSorted: !sortEducators.isSorted,
                }),
            );
            break;
        default:
            break;
    }
};
